export default __webpack_public_path__ + "static/media/about_us_bg.df4f9900.png";